import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

const activeSublink = ({isActive}) => (isActive ? "active" : "link")
const activeLink = ({isActive}) => (isActive ? "active" : "link")

const SidebarItem = ({ item, isOpen, onClick }) => {
  const [expandMenu, setExpandMenu] = useState(false);

  if (item.childrens) {
        return (<div className={expandMenu ? "sidebar-item s-parent open" : "sidebar-item s-parent"}>
            <div className='sidebar-title'>
                <span className="flex items-center cursor-pointer" onClick={() => setExpandMenu(!expandMenu)}>
                    <item.icon className="h-8 w-6 text-white" aria-hidden="true" />
                    <span className="ml-2 text-white">{item.title}</span>
                    <ChevronRightIcon
                        className={`h-4 w-4 text-white transition-transform ${
                        expandMenu ? 'transform rotate-90' : ''
                        }`}
                    />
                </span>
            </div>
            {<div className={`sidebar-content transition-all duration-200 
                ${expandMenu ? 'max-h-[1000px]' : 'max-h-0 overflow-hidden'}`}
            >
                {item.childrens.map((child, index) => {
                    return (
                        <div
                            key={index}
                            className={`s-child transition-transform duration-200 
                            ${expandMenu ? 'translate-y-0' : '-translate-y-1/4'}`}
                        >
                            <NavLink to={child.path} className={activeSublink} >
                                <div className='sidebar-item'>
                                    <div className='sidebar-title'>
                                        <span>
                                        {<div className="min-h-[2rem] py-1 leading-snug text-white ml-8">- {child.title}</div>}
                                        </span>
                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    )
                })}
            </div>}
        </div>)
    } else {
        return (<NavLink to={item.path} className={activeLink}>
            <div className='sidebar-item s-parent'>
                <div className='sidebar-title'>
                    <span className="flex items-center">
                        <item.icon className="h-8 w-6 text-white" aria-hidden="true" />
                        <span className="ml-2 text-white">{item.title}</span>
                    </span>
                </div>
            </div>
        </NavLink>)
    }
}

export default SidebarItem